import { useCallback } from 'react';

import { getApolloClient } from '@confluence/graphql';

import { getSkipContentAndTypes } from './getSkipContentAndTypes';
import { BreadcrumbsQuery } from './BreadcrumbsQuery.graphql';
import type {
	BreadcrumbsQuery as BreadcrumbsQueryType,
	BreadcrumbsQueryVariables,
} from './__types__/BreadcrumbsQuery';

export const useForceRefetchBreadcrumbs = (
	contentId: string,
	spaceKey: string,
	matchName?: string,
) => {
	return useCallback(async () => {
		const { skipContent } = getSkipContentAndTypes(matchName);
		if (contentId || skipContent) {
			try {
				await getApolloClient().query<
					BreadcrumbsQueryType,
					BreadcrumbsQueryVariables & { cacheBuster: number }
				>({
					query: BreadcrumbsQuery,
					context: { single: true },
					fetchPolicy: 'network-only',
					variables: {
						spaceKey,
						contentId,
						skipContent: !contentId,
						cacheBuster: Date.now(),
					},
				});
			} catch (error) {
				// NOTE: We intentionally swallow any possible error here as this query is only aimed
				// populate the cache with just published content. Should any error occur here after
				// successful publishing the page, the Apollo cache for the query will be invalidated
			}
		}
	}, [contentId, spaceKey, matchName]);
};
